import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "config/api.config";
import { MailCount } from "types/dispatch.types";
import { ValidationErrors } from "types/masterdata.types";

export const dispatchApi = createApi({
  reducerPath: "dispatch",
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    sendAccessData: builder.mutation<
      ValidationErrors,
      {
        kundennummer: number;
        forTreuhaender: boolean;
      }
    >({
      query: (params) => ({
        method: "POST",
        url: "dispatch/SendAccessData",
        params,
      }),
    }),
    sendAkbLetter: builder.mutation<
      ValidationErrors,
      {
        kundennummer: number;
      }
    >({
      query: (params) => ({
        method: "POST",
        url: "dispatch/SendAkbLetter",
        params,
      }),
    }),
    sendBlFbLetter: builder.mutation<
      ValidationErrors,
      {
        kundennummer: number;
      }
    >({
      query: (params) => ({
        method: "POST",
        url: "dispatch/sendBlFbLetter",
        params,
      }),
    }),
    sendStatusUpdateMail: builder.mutation<
      ValidationErrors,
      {
        treuhandstelleId: number;
      }
    >({
      query: (params) => ({
        method: "POST",
        url: "dispatch/SendStatusupdateMail",
        params,
      }),
    }),
    sendBlOkThNotOkMails: builder.mutation<
      ValidationErrors,
      {
        kundennummer?: number;
        forceResend: boolean;
      }
    >({
      query: (params) => ({
        method: "POST",
        url: "management/sendBlOkThNotOkMails",
        params,
      }),
    }),
    getOpenM41Mails: builder.query<MailCount, void>({
      query: () => ({
        method: "GET",
        url: "management/GetOpenM41Mails",
      }),
    }),
    sendThsAkb: builder.mutation<
      ValidationErrors,
      {
        treuhandstelleId: number;
      }
    >({
      query: (params) => ({
        method: "POST",
        url: "dispatch/SendThsAkbLetter",
        params,
      }),
    }),
  }),
});

export const {
  useSendAccessDataMutation,
  useSendAkbLetterMutation,
  useSendBlFbLetterMutation,
  useSendStatusUpdateMailMutation,
  useSendBlOkThNotOkMailsMutation,
  useGetOpenM41MailsQuery,
  useSendThsAkbMutation,
} = dispatchApi;
